
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/breaker",
      function () {
        return require("private-next-pages/breaker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/breaker"])
      });
    }
  